import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, DestroyRef, inject, output, signal, model, input, effect, computed, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { TankPricePreview, Tanque } from 'src/app/models/tanque.model';
import { Building } from 'src/app/models/building.model';
import { Settlement } from 'src/app/models/settlement.model';
import { Unit } from 'src/app/models/unit.model';
import { IconsService } from 'src/app/shared/services/icons.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { catchError, combineLatest, concatMap, distinctUntilChanged, finalize, forkJoin, from, map, Observable, of, startWith, switchMap, tap, toArray } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PlanFile } from 'src/app/models/plan-file.model';
import { v4 as uuidv4 } from 'uuid';
import { NfcTagValidator } from 'src/app/shared/validators/nfc-tag';
import { TankApprovalsService } from 'src/app/services/tank-approvals.service';
import { InventoryAgreement } from 'src/app/models/inventory-agreement.interface';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { normalizeOptionalBoolean } from 'src/app/shared/utils/contract-term.utils';
import { environment } from 'src/environments/environment';
import {
  calculateInitialInventoryLiters,
  calculateInventoryAmount,
  calculateInventoryPaymentProgress,
  calculateRemainingInventoryAmount,
  classifyInventoryAgreement,
  findLeaveInventoryAgreement,
  getInventoryAgreementHelp,
  getInventoryAgreementLabel,
  InventoryAgreementKind
} from './inventory-initial.utils';

interface InventoryPaymentUploadResult {
  type: 'pdf' | 'xml';
  success: boolean;
}

@Component({
  selector: 'app-form-tanque',
  template: `
    <form [formGroup]="tanqueForm" (ngSubmit)="saveForm()" class="form-tanque-create">
      
      <div class="form-group required mb-4 form-tanque-item full">
        <label for="name" class="form-label ms-2">Nombre del tanque</label>
        <input type="text" class="form-control" id="name" formControlName="name" placeholder="Nombre">
        <div *ngIf="ufc['name'].touched && ufc['name'].invalid">
          <div *ngIf="ufc['name'].errors?.['required']" class="text-danger text-sm">El nombre es requerido.</div>
        </div>
      </div>

      <div class="form-group required mb-3 form-tanque-item">
        <label for="capacidad" class="form-label ms-2">Capacidad (lts.)</label>
        <input type="number" min="0.01" step="0.01" class="form-control" id="capacidad" formControlName="capacidad" placeholder="Capacidad">
        <div *ngIf="ufc['capacidad'].touched && ufc['capacidad'].invalid">
          <div *ngIf="ufc['capacidad'].errors?.['required']" class="text-danger text-sm">La capacidad es requerida.</div>
          <div *ngIf="ufc['capacidad'].errors?.['min']" class="text-danger text-sm">La capacidad debe ser mayor a cero.</div>
        </div>
      </div>

      <div class="form-group required mb-3 form-tanque-item">
        <label for="optimal" class="form-label ms-2">Nivel óptimo %</label>
        <input type="text" class="form-control" id="optimal" formControlName="optimal" placeholder="Nivel óptimo %">
        <div *ngIf="ufc['optimal'].touched && ufc['optimal'].invalid">
          <div *ngIf="ufc['optimal'].errors?.['required']" class="text-danger text-sm">El nivel óptimo es requerido.</div>
        </div>
      </div>

      <div class="form-group required mb-3 form-tanque-item">
        <label for="limite" class="form-label ms-2">Limite de carga %</label>
        <input type="text" class="form-control" id="limite" formControlName="limite" placeholder="limite %">
        <div *ngIf="ufc['limite'].touched && ufc['limite'].invalid">
          <div *ngIf="ufc['limite'].errors?.['required']" class="text-danger text-sm">El límite de carga es requerido.</div>
        </div>
      </div>

      <div class="form-group required mb-3 form-tanque-item">
        <label for="limite_inferior" class="form-label ms-2">Limite inferior %</label>
        <input type="text" class="form-control" id="limite_inferior" formControlName="limite_inferior" placeholder="Limite inferior %">
        <div *ngIf="ufc['limite_inferior'].touched && ufc['limite_inferior'].invalid">
          <div *ngIf="ufc['limite_inferior'].errors?.['required']" class="text-danger text-sm">El límite inferior es requerido.</div>
        </div>
      </div>

      <div class="form-group required mb-3 form-tanque-item">
        <label for="latitude" class="form-label ms-2">Latitud</label>
        <input type="text" class="form-control" id="latitude" formControlName="latitude" placeholder="Latitud">
        <div *ngIf="ufc['latitude'].touched && ufc['latitude'].invalid">
          <div *ngIf="ufc['latitude'].errors?.['required']" class="text-danger text-sm">La latitud es requerida.</div>
        </div>
      </div>

      <div class="form-group required mb-3 form-tanque-item">
        <label for="longitude" class="form-label ms-2">Longitud</label>
        <input type="text" class="form-control" id="longitude" formControlName="longitude" placeholder="Longitud">
        <div *ngIf="ufc['longitude'].touched && ufc['longitude'].invalid">
          <div *ngIf="ufc['longitude'].errors?.['required']" class="text-danger text-sm">La longitud es requerida.</div>
        </div>
      </div>

      <div class="form-group mb-3 form-tanque-item">
        <label for="external_id" class="form-label ms-2">ANOVA</label>
        <input type="text" class="form-control" id="external_id" formControlName="external_id" placeholder="">
      </div>
      
      <div class="form-group required mb-3 form-tanque-item">
        <label for="folio_qr" class="form-label ms-2">ID Tag NFC</label>
        <input type="text" class="form-control" id="folio_qr" formControlName="folio_qr" placeholder="Folio QR">
        <div *ngIf="ufc['folio_qr'].touched && ufc['folio_qr'].invalid">
          <div *ngIf="ufc['folio_qr'].errors?.['required']" class="text-danger text-sm">El QR es requerido.</div>
          <div *ngIf="ufc['folio_qr'].errors?.['tagExist']" class="text-danger text-sm">El QR ya existe</div>
        </div>
      </div>
      
      <div class="form-group required mb-3 form-tanque-item">
        <label for="name" class="form-label ms-2">Condominio/Comercio</label>
        <app-infinite-select
          [fetchPage]="settlementsFetcher"
          [pageSize]="settlementsPageSize"
          [labelKey]="'name'"
          [valueKey]="'id'"
          [placeholder]="'Selecciona un condominio'"
          [panelMaxHeight]="260"
          [triggerClass]="'form-select'"
          [showCaret]="false"
          [seedItems]="seededSettlements"
          (selectionChange)="selectSettlement($event)"
          formControlName="settlement_id"
          [(selectedSettlement)]="selectedSettlement"
        ></app-infinite-select>
        <div *ngIf="ufc['settlement_id'].touched && ufc['settlement_id'].invalid">
          <div *ngIf="ufc['settlement_id'].errors?.['required']" class="text-danger text-sm">El condominio/comercio es requerido.</div>
        </div>
      </div>

      <div class="form-group required mb-3 form-tanque-item">
        <label for="name" class="form-label ms-2">Edificio</label>
        <select class="form-select" formControlName="building_id" [disabled]="buildings!.length>0">
          <option value="" disabled selected>Selecciona un edificio</option>
          <option *ngFor="let building of buildings" [value]="building!.id">{{ building?.name }}</option>
        </select>
        <div *ngIf="ufc['building_id'].touched && ufc['building_id'].invalid">
          <div *ngIf="ufc['building_id'].errors?.['required']" class="text-danger text-sm">El edificio es requerido.</div>
        </div>
      </div>

      <section id="inventory-initial-change" class="inventory-fields form-tanque-item full mb-3">
        <div class="form-group required">
          <label for="porcentaje_inicial" class="form-label ms-2">Inventario inicial (%)</label>
          <input type="number" min="0" max="100" step="0.01" class="form-control" id="porcentaje_inicial" formControlName="initial_percentage" placeholder="0 a 100">
          <div *ngIf="ufc['initial_percentage'].touched && ufc['initial_percentage'].invalid">
            <div *ngIf="ufc['initial_percentage'].errors?.['required']" class="text-danger text-sm">El inventario inicial es requerido.</div>
            <div *ngIf="ufc['initial_percentage'].errors?.['min'] || ufc['initial_percentage'].errors?.['max']" class="text-danger text-sm">Captura un porcentaje entre 0 y 100.</div>
            <div *ngIf="ufc['initial_percentage'].errors?.['pattern']" class="text-danger text-sm">Usa máximo dos decimales.</div>
          </div>
        </div>
        <div class="form-group">
          <label for="initial_inventory_liters" class="form-label ms-2">Inventario inicial (L)</label>
          <output id="initial_inventory_liters" class="form-control inventory-liters-output" aria-live="polite">
            {{ initialInventoryLiters() === null ? '—' : (initialInventoryLiters() | number:'1.0-2') }}
          </output>
        </div>
      </section>

      @if (ufc['building_id'].value && initialInventoryLiters() !== null) {
        <section id="inventory-economic-values" class="inventory-economic-summary form-tanque-item full mb-3" aria-live="polite">
          <div class="inventory-section-heading">
            <h5>Valores económicos iniciales</h5>
            <small>Información calculada por el servicio; no es editable.</small>
          </div>
          @if (pricePreviewLoading()) {
            <p class="inventory-loading">Consultando precio y costo…</p>
          } @else {
            <div class="inventory-value-grid">
              <div class="inventory-value">
                <span>Precio CRE</span>
                <strong>{{ pricePreview().region_price === null ? '—' : (pricePreview().region_price | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
                <small>por litro</small>
              </div>
              <div class="inventory-value">
                <span>Precio de venta</span>
                <strong>{{ salePrice() === null ? '—' : (salePrice() | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
                <small>por litro</small>
              </div>
              <div class="inventory-value">
                <span>Costo UDN</span>
                <strong>{{ cost() === null ? '—' : (cost() | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
                <small>por litro</small>
              </div>
            </div>
          }
        </section>
      }

      <div class="form-group mb-3 form-tanque-item">
        <label for="porcentaje_final" class="form-label ms-2">% Final</label>
        <input type="text" class="form-control" id="porcentaje_final" formControlName="final_percentage" placeholder="% Final">
        <div *ngIf="ufc['final_percentage'].touched && ufc['final_percentage'].invalid">
          <div *ngIf="ufc['final_percentage'].errors?.['required']" class="text-danger text-sm">El límite inferior es requerido.</div>
        </div>
      </div>

      <div class="form-group mb-3 form-tanque-item">
        <label class="form-label ms-2">Planos</label>
        <div class="plan-files-container">
        @for (plan of planFiles(); track $index) {
          <app-upload-file [approvalComplete]="approvalComplete()" [(file)]="plan.file" (onDelete)="removeFile(plan)"></app-upload-file>
        }
        </div>
        <button [disabled]="approvalComplete()" type="button" class="btn btn-zazz-dark ms-2 shadow-sm" (click)="!approvalComplete() && newEmptyFile.emit(true)">
          <fa-icon [icon]="icons.faSquarePlus"></fa-icon>
          &nbsp;
          <span>Agregar archivo</span>
        </button>
        <div class="form-check">
          <input [disabled]="approvalComplete()" class="form-check-input" type="checkbox" value="" id="flexCheckDefault" (change)="parentTanque($event)">
          <label class="form-check-label" for="flexCheckDefault">
            ¿Tiene un tanque padre?
          </label>
        </div>
        <div *ngIf="hasParent">
          <label for="parent_tanque_id" class="form-label ms-2">Tanque padre</label>
        <select class="form-select" formControlName="parent_tanque_id">
          <option selected>Selecciona un tanque</option>
          <option *ngFor="let tanque of tanques" [value]="tanque.id">{{tanque?.name}}</option>
        </select>
        </div>
        @if (tanque?.id) {
          <div class="approval-status">
            <app-tank-approvals [(approvalComplete)]="approvalComplete" [tankId]="tanque?.id"></app-tank-approvals>
          </div>
        }
      </div>

      <section id="inventory-agreement-change" class="inventory-agreement-fields form-tanque-item full mb-3">
        <div class="form-group required">
          <label for="inventory_agreement_id" class="form-label">Acuerdo sobre inventario inicial</label>
          <select
            id="inventory_agreement_id"
            class="form-select"
            [class.inventory-agreement-locked]="isZeroInitialInventory()"
            [attr.aria-disabled]="isZeroInitialInventory()"
            [attr.tabindex]="isZeroInitialInventory() ? -1 : null"
            formControlName="inventory_agreement_id"
            (mousedown)="preventAgreementChange($event)"
            (keydown)="preventAgreementChange($event)"
          >
            <option value="" disabled>Selecciona un acuerdo</option>
            <option *ngFor="let agreement of agreementsSelected()" [value]="agreement.id">{{ agreementDisplayName(agreement) }}</option>
          </select>
          <div *ngIf="ufc['inventory_agreement_id'].touched && ufc['inventory_agreement_id'].invalid">
            <div *ngIf="ufc['inventory_agreement_id'].errors?.['required']" class="text-danger text-sm">El acuerdo es requerido.</div>
          </div>
          @if (isZeroInitialInventory()) {
            <small class="inventory-zero-notice">Con inventario inicial en cero, “Dejar inventario” es la única opción disponible.</small>
          }
        </div>
        @if (selectedAgreement()) {
          <div class="inventory-agreement-help" aria-live="polite">
            <p>{{ selectedAgreementHelp() }}</p>
          </div>
        }
      </section>

      @if (selectedAgreementKind() === 'leave') {
        <section id="leave-inventory-resolution" class="inventory-resolution form-tanque-item full mb-3">
          <div class="inventory-section-heading">
            <h5>Costo de reposición</h5>
            <small>Litros iniciales por el costo de la planta a la UDN.</small>
          </div>
          <div class="inventory-value-grid compact">
            <div class="inventory-value">
              <span>Costo de reposición del inventario</span>
              <strong>{{ replacementCostPreview() === null ? '—' : (replacementCostPreview() | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
              @if (inventoryReplacementCost() === null && replacementCostPreview() !== null) {
                <small>Calculado con los litros iniciales y el costo por litro disponible.</small>
              }
            </div>
          </div>
        </section>
      }

      @if (selectedAgreementKind() === 'credit-note') {
        <section id="credit-note-resolution" class="inventory-resolution form-tanque-item full mb-3">
          <div class="inventory-section-heading">
            <h5>Nota de crédito</h5>
            <small>El descuento se aplica únicamente al consumo de gas.</small>
          </div>
          <div class="inventory-value-grid">
            <div class="inventory-value">
              <span>Total por debitar</span>
              <strong>{{ creditNoteTotal() === null ? '—' : (creditNoteTotal() | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
            </div>
            <div class="inventory-value">
              <span>Monto debitado</span>
              <strong>{{ (debitedAmount() ?? 0) | currency:'MXN':'symbol-narrow':'1.2-2' }}</strong>
            </div>
            <div class="inventory-value">
              <span>Monto por debitar</span>
              <strong>{{ creditNoteRemaining() === null ? '—' : (creditNoteRemaining() | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
            </div>
          </div>
          <div class="inventory-resolution-actions">
            @if (configuredCreditUnit()) {
              <small>Unidad configurada: <strong>{{ unitDisplayName(configuredCreditUnit()!) }}</strong></small>
            }
            <button type="button" class="btn btn-outline-dark" [disabled]="approvalComplete()" (click)="openCreditNoteModal(creditNoteModal)">
              Configurar nota de crédito
            </button>
          </div>
        </section>
      }

      @if (selectedAgreementKind() === 'gas-company' || selectedAgreementKind() === 'client') {
        <section id="inventory-payment-resolution" class="inventory-resolution form-tanque-item full mb-3">
          <div class="inventory-section-heading">
            <h5>Pago de inventario a {{ invoiceCounterparty() }}</h5>
            <small>Importe calculado con los litros del inventario inicial.</small>
          </div>
          @if (selectedAgreementKind() === 'gas-company') {
            <div class="form-group required inventory-agreed-price">
              <label for="external_gas_company_agreed_price" class="form-label">Precio pactado con la gasera por litro</label>
              <input
                type="number"
                min="0.01"
                step="0.01"
                class="form-control"
                id="external_gas_company_agreed_price"
                formControlName="external_gas_company_agreed_price"
                placeholder="0.00"
              >
              @if (ufc['external_gas_company_agreed_price'].touched && ufc['external_gas_company_agreed_price'].invalid) {
                <div class="text-danger text-sm">Captura un precio mayor a cero.</div>
              }
            </div>
          }
          <div class="inventory-value-grid compact">
            <div class="inventory-value">
              <span>Total por pagar</span>
              <strong>{{ inventoryPaymentCalculatedTotal() === null ? '—' : (inventoryPaymentCalculatedTotal() | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
            </div>
            <div class="inventory-value">
              <span>Monto pagado</span>
              <strong>{{ inventoryPaymentProgress().paidAmount === null ? '—' : (inventoryPaymentProgress().paidAmount | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
            </div>
            <div class="inventory-value">
              <span>Monto por pagar</span>
              <strong>{{ inventoryPaymentProgress().pendingAmount === null ? '—' : (inventoryPaymentProgress().pendingAmount | currency:'MXN':'symbol-narrow':'1.2-2') }}</strong>
            </div>
            <div class="inventory-value">
              <span>Estado</span>
              <strong>{{ inventoryPaymentDocumentStatusLabel() }}</strong>
            </div>
            <div class="inventory-value">
              <span>Factura PDF</span>
              @if (inventoryPaymentPdfUrl()) {
                <a [href]="inventoryPaymentPdfUrl()" target="_blank" rel="noopener noreferrer">Ver PDF</a>
              } @else {
                <strong>{{ hasInventoryPaymentPdf() ? 'Cargada' : 'Pendiente' }}</strong>
              }
            </div>
            <div class="inventory-value">
              <span>Factura XML</span>
              @if (inventoryPaymentXmlUrl()) {
                <a [href]="inventoryPaymentXmlUrl()" target="_blank" rel="noopener noreferrer" download>Descargar XML</a>
              } @else {
                <strong>{{ hasInventoryPaymentXml() ? 'Cargada' : 'Pendiente' }}</strong>
              }
            </div>
          </div>
          <div class="inventory-resolution-actions">
            @if (!idTank()) {
              <small>Guarda el tanque para habilitar la carga de la factura.</small>
            } @else if (inventoryAgreementRequiresSave()) {
              <small>Guarda el cambio de acuerdo antes de cargar la factura.</small>
            }
            <button
              type="button"
              class="btn btn-outline-dark"
              [disabled]="!idTank() || inventoryAgreementRequiresSave() || approvalComplete()"
              (click)="openInventoryPaymentModal(inventoryPaymentModal)"
            >
              Cargar factura PDF y XML
            </button>
          </div>
        </section>
      }

      <div class="form-group mb-3 form-tanque-item">
        @if (tanque?.id && tanque?.trajectory_video_url) {
          <label class="form-label ms-2">Video evidencia</label>
          <app-video-preview [video]="tanque?.trajectory_video_url"></app-video-preview>
          <button [disabled]="approvalComplete()" type="button" class="btn btn-zazz-dark ms-2 shadow-sm" (click)="deleteVideo()">
          <fa-icon [icon]="icons.faTrashCan"></fa-icon>
          &nbsp;
          <span>Eliminar video</span>
          </button>
          <br>
          <label for="trajectory_distance" class="form-label ms-2">Trayectoria</label>
          <input type="text" class="form-control" id="trajectory_distance" formControlName="trajectory_distance" placeholder="Trayectoria (m)">
          <div *ngIf="ufc['trajectory_distance'].touched && ufc['trajectory_distance'].invalid">
            <div *ngIf="ufc['trajectory_distance'].errors?.['required']" class="text-danger text-sm">La trayectoria es requerida.</div>
          </div>
          
        }
      </div>

      <div class="form-group mb-2 mt-5 text-end col-12">
        <button type="button" class="btn btn-link me-2" routerLink="/combustibles/tanques">Cancelar</button>
        <button type="submit" class="btn btn-zazz-dark ms-2 shadow-sm" [disabled]="loading || approvalComplete()">
          <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="me-2" *ngIf="loading"></fa-icon>
          <fa-icon [icon]="icons.faSave" class="me-2" *ngIf="!loading"></fa-icon>
          Guardar
        </button>
      </div>
    </form>

    <ng-template #creditNoteModal>
      <div class="modal-header">
        <h5 class="modal-title">Configurar nota de crédito</h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="dismissActiveModal()"></button>
      </div>
      <div class="modal-body" [formGroup]="creditNoteForm">
        <div class="form-group required">
          <label for="inventory_credit_unit_id" class="form-label">Unidad que recibirá el descuento</label>
          <select id="inventory_credit_unit_id" class="form-select" formControlName="unit_id" [disabled]="unitsLoading()">
            <option value="" disabled>Selecciona una unidad</option>
            <option *ngFor="let unit of units()" [value]="unit.id">{{ unitDisplayName(unit) }}</option>
          </select>
          @if (unitsLoading()) {
            <small class="text-muted">Consultando unidades…</small>
          } @else if (units().length === 0) {
            <small class="text-muted">No se encontraron unidades para este condominio o comercio.</small>
          }
          @if (creditNoteForm.controls['unit_id'].touched && creditNoteForm.controls['unit_id'].invalid) {
            <div class="text-danger text-sm">Selecciona una unidad.</div>
          }
        </div>
        @if (isResidentialSettlement()) {
          <div class="form-check inventory-stamp-option">
            <input class="form-check-input" type="checkbox" id="stamp_inventory_credit_note" formControlName="stamp_inventory_credit_note">
            <label class="form-check-label" for="stamp_inventory_credit_note">Emitir la nota de crédito timbrada</label>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" (click)="dismissActiveModal()">Cancelar</button>
        <button type="button" class="btn btn-zazz-dark" [disabled]="creditConfigurationSaving() || unitsLoading()" (click)="saveCreditNoteConfiguration()">
          Guardar configuración
        </button>
      </div>
    </ng-template>

    <ng-template #inventoryPaymentModal>
      <div class="modal-header">
        <h5 class="modal-title">Factura de {{ invoiceCounterparty() }}</h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="dismissActiveModal()"></button>
      </div>
      <div class="modal-body">
        <p class="text-muted">Adjunta los archivos emitidos por {{ invoiceCounterparty() }}. Puedes reemplazar cualquiera de los dos documentos.</p>
        <div class="mb-3">
          <label for="inventory_payment_pdf" class="form-label">Factura PDF</label>
          <input id="inventory_payment_pdf" type="file" class="form-control" accept=".pdf,application/pdf" (change)="selectInventoryPaymentFile($event, 'pdf')">
          @if (hasInventoryPaymentPdf()) {
            <small class="text-success">Actualmente hay un PDF cargado.</small>
          }
        </div>
        <div>
          <label for="inventory_payment_xml" class="form-label">Factura XML</label>
          <input id="inventory_payment_xml" type="file" class="form-control" accept=".xml,text/xml,application/xml" (change)="selectInventoryPaymentFile($event, 'xml')">
          @if (hasInventoryPaymentXml()) {
            <small class="text-success">Actualmente hay un XML cargado.</small>
          }
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" (click)="dismissActiveModal()">Cancelar</button>
        <button
          type="button"
          class="btn btn-zazz-dark"
          [disabled]="invoiceUploading() || (!invoicePdfFile() && !invoiceXmlFile())"
          (click)="uploadInventoryPaymentFiles()"
        >
          Guardar archivos
        </button>
      </div>
    </ng-template>
  `,
  styleUrls: ['./form-tanque.component.scss']
})
export class FormTanqueComponent implements OnInit {
  tankApprovalsService = inject(TankApprovalsService);
  selectedSettlement = model<any>(null);
  isEdition = input<boolean>(false);
  onLoading = output<boolean>();
  newEmptyFile = output<boolean>();
  deleteVideoEvent = output<boolean>();
  @Input() tanque: Tanque | null = null;
  @Input() loading: any;
  @Input() permissions: any;
  @Output() updateForm = new EventEmitter<any>();
  @Output() cancelForm = new EventEmitter<any>();
  idTank = signal<number | null>(null);
  savedInventoryAgreementId = signal<number | null>(null);
  agreements = signal<InventoryAgreement[]>([]);
  agreementsSelected = computed<InventoryAgreement[]>(() => this.selectedSettlement() ? this.agreements() : []);
  initialInventoryLiters = signal<number | null>(null);
  isZeroInitialInventory = signal(false);
  selectedAgreementId = signal<number | null>(null);
  selectedAgreement = computed<InventoryAgreement | undefined>(() =>
    this.agreements().find(agreement => agreement.id === this.selectedAgreementId())
  );
  selectedAgreementKind = computed<InventoryAgreementKind>(() => classifyInventoryAgreement(this.selectedAgreement()));
  selectedAgreementHelp = computed(() => getInventoryAgreementHelp(this.selectedAgreement()));
  inventoryAgreementRequiresSave = computed(() =>
    Boolean(this.idTank()) && this.savedInventoryAgreementId() !== this.selectedAgreementId()
  );
  pricePreview = signal<TankPricePreview>({ region_price: null, sale_price: null, cost: null });
  pricePreviewLoading = signal(false);
  debitedAmount = signal<number | null>(null);
  inventoryReplacementCost = signal<number | null>(null);
  inventoryPaymentTotal = signal<number | null>(null);
  externalGasCompanyPrice = signal<number | null>(null);
  units = signal<Unit[]>([]);
  unitsLoading = signal(false);
  creditConfigurationSaving = signal(false);
  configuredCreditUnit = signal<Unit | null>(null);
  invoicePdfFile = signal<File | null>(null);
  invoiceXmlFile = signal<File | null>(null);
  invoiceUploading = signal(false);
  hasInventoryPaymentPdf = signal(false);
  hasInventoryPaymentXml = signal(false);
  inventoryPaymentPdfUrl = signal<string | null>(null);
  inventoryPaymentXmlUrl = signal<string | null>(null);
  salePrice = computed(() => this.pricePreview().sale_price);
  cost = computed(() => this.pricePreview().cost);
  replacementCostPreview = computed(() =>
    this.inventoryReplacementCost() ?? calculateInventoryAmount(this.initialInventoryLiters(), this.cost())
  );
  creditNoteTotal = computed(() => calculateInventoryAmount(this.initialInventoryLiters(), this.salePrice()));
  creditNoteRemaining = computed(() => calculateRemainingInventoryAmount(
    this.creditNoteTotal(),
    this.debitedAmount() ?? 0
  ));
  inventoryPaymentCalculatedTotal = computed(() => {
    const price = this.selectedAgreementKind() === 'gas-company'
      ? this.externalGasCompanyPrice()
      : this.salePrice();
    return calculateInventoryAmount(this.initialInventoryLiters(), price) ?? this.inventoryPaymentTotal();
  });
  inventoryPaymentProgress = computed(() => calculateInventoryPaymentProgress(
    this.inventoryPaymentCalculatedTotal(),
    this.hasInventoryPaymentPdf(),
    this.hasInventoryPaymentXml()
  ));
  inventoryPaymentDocumentStatusLabel = computed(() => {
    switch (this.inventoryPaymentProgress().documentStatus) {
      case 'complete':
        return 'Pagado';
      case 'incomplete':
        return 'Documentación incompleta';
      default:
        return 'Pendiente';
    }
  });
  invoiceCounterparty = computed(() => this.selectedAgreementKind() === 'gas-company' ? 'gasera' : 'cliente');
  isResidentialSettlement = computed(() => Number(this.selectedSettlement()?.tipo) === 0);
  planFiles = model<PlanFile[] | null>(null);
  tanqueForm: FormGroup = new FormGroup({});
  creditNoteForm: FormGroup = new FormGroup({});
  profile: any;
  seededSettlements: Settlement[] = [];
  buildings: Building[] = [];
  tanques: any = [];
  approvalComplete = model<boolean>(false);
  private readonly destroyRef = inject(DestroyRef);
  private activeModalRef?: NgbModalRef;

  hasParent: boolean = false;
  settlementsPageSize = 10;
  settlementsFetcher = (params: any) => {
    const payload: any = {
      page: params.page,
      per_page: params.per_page
    };
    if (this.profile?.id) {
      payload.profile_id = this.profile.id;
    }
    if (params.search) {
      payload.name = params.search;
    }
    return this.store.getSettlements(payload);
  };
  storageService = inject(StorageService);
  constructor(
    private fb: FormBuilder,
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    private modalService: NgbModal
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.initForm();
    this.initCreditNoteForm();
    this.setupInventoryControls();
    effect(() => {
      const complete = this.approvalComplete();
      if (complete) {
        Object.keys(this.tanqueForm.controls).forEach(key => this.tanqueForm.controls[key].disable());
        this.tanqueForm.updateValueAndValidity();
      }
    });
    effect(() => this.updateAgreementValidators(this.selectedAgreementKind()));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tanque'] && changes['tanque'].currentValue && changes['tanque'].currentValue.id) {
      const tank = changes['tanque'].currentValue as Tanque;
      this.idTank.set(tank.id!);
      this.savedInventoryAgreementId.set(this.toNullableNumber(tank.inventory_agreement_id));
      this.hydrateEconomicData(tank);
      this.tanqueForm.patchValue(tank);
      this.tanqueForm.controls['settlement_id'].setValue(tank.settlement?.id);
      this.tanqueForm.controls['building_id'].setValue(tank.building?.id);
      this.tanqueForm.controls['parent_tanque_id'].setValue(
        [undefined, null, ''].includes(tank.parent_tanque_id as any)
          ? false: true
      );
      this.hasParent = this.tanqueForm.controls['parent_tanque_id'].value;
      this.updateParentValidator();
      if (tank.settlement) {
        this.selectedSettlement.set(tank.settlement);
        this.seededSettlements = [tank.settlement];
        this.getBuildings(tank.settlement.id);
      }
    }
  }

  ngOnInit(): void {
    this.store.getTanques({ page: 1, per_page: 1000, profile_id: this.profile.id })
      .subscribe({
        next: (tanque: any) => {
          this.tanques = tanque.data;
          this.setQrValidators();
        },
        complete: () => {
          if (this.tanque?.id) {
            this.loadPlanFile();
          }
        }
      });
  }

  deleteVideo() {
    if (this.idTank()) {
      this.store.deleteVideo(this.idTank()!).subscribe({
        next: () => {
          this.deleteVideoEvent.emit(true);
          this.toastr.success('El video ha sido eliminado');
        },
        error: () => {
          this.deleteVideoEvent.emit(false);
          this.toastr.error('El archivo no ha podido ser eliminado');
        }
      });
    }
  }

  setQrValidators(currentId = this.idTank()) {
    const control = this.tanqueForm.controls['folio_qr'];
      control.clearAsyncValidators();
      control.setValidators([Validators.required]);
      control.setAsyncValidators([
        NfcTagValidator(this.tankApprovalsService, currentId)
      ]);
      control.updateValueAndValidity();
  }

  removeFile(plan: PlanFile) {
    if (this.isEdition()) {
      if (plan.id) {
        this.store.removeTankPlan(plan.tanque_id, plan.id).subscribe({
          next: (res) => {
            this.toastr.success('El archivo ha sido eliminado');
            this.removeFileFromList(plan);
          },
          error: () => {
            this.toastr.error('No se ha podido eliminar el archivo');
          }
        });
      } else {
        this.removeFileFromList(plan);
      }
    } else {
      this.removeFileFromList(plan);
    }
  }

  removeFileFromList(plan: PlanFile) {
    this.planFiles.update((prev: PlanFile[] | null) => {
      const current = prev ?? [];
      const newList = [...current.filter(p => p.uiId !== plan.uiId)];
      return newList;
    });
  }

  loadPlanFile() {
    this.store.getTankPlans(this.tanque?.id!)
      .pipe(
        switchMap((files: any) => {
          if (Array.isArray(files)) {
            return from(files).pipe(
              concatMap((f: PlanFile) => {
                return (this.store.getBlobFile(f.file_url, false) as Observable<any>).pipe(
                  tap((blob: Blob) => {
                    if (blob && f) {
                      const file = new File([blob], f.name, {
                        type: blob.type
                      });
                      this.planFiles.update((prevFiles: PlanFile[] | null) => {
                        const newFile: PlanFile = {...f, file, uiId: uuidv4()}
                        const newList = prevFiles ? [...prevFiles, newFile] : [newFile];

                        return newList;
                      });
                    }
                  })
                )
              }),
              toArray()
            );
          }
          return of(null);
        })
      ).subscribe({
        next: (data) => {
          console.log(`File Data Download Completed...`);
        }
      })
  }

  initForm() {
    this.tanqueForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      capacidad: ['', [Validators.required, Validators.min(0.01)]],
      limite: ['', Validators.required],
      limite_inferior: ['', Validators.required],
      optimal: ['', Validators.required],
      folio_qr: [''],
      latitude: ['', Validators.required],
      longitude: ['', Validators.required],
      settlement_id: ['', Validators.required],
      parent_tanque_id: [null],
      inventory_agreement_id: ['', Validators.required],
      building_id: ['', Validators.required],
      external_id: [''],
      external_gas_company_agreed_price: [''],
      initial_percentage: ['', [Validators.required, Validators.min(0), Validators.max(100), Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      final_percentage: [''],
      trajectory_distance: [{value: '', disabled: true}]
    });
  }

  initCreditNoteForm() {
    this.creditNoteForm = this.fb.group({
      unit_id: ['', Validators.required],
      stamp_inventory_credit_note: [false]
    });
  }

  get ufc() {
    return this.tanqueForm.controls;
  }

  preventAgreementChange(event: Event) {
    if (this.isZeroInitialInventory()) {
      event.preventDefault();
    }
  }

  agreementDisplayName(agreement: InventoryAgreement) {
    return getInventoryAgreementLabel(agreement);
  }

  private setupInventoryControls() {
    const capacityControl = this.tanqueForm.controls['capacidad'];
    const percentageControl = this.tanqueForm.controls['initial_percentage'];
    const agreementControl = this.tanqueForm.controls['inventory_agreement_id'];
    const buildingControl = this.tanqueForm.controls['building_id'];
    const gasCompanyPriceControl = this.tanqueForm.controls['external_gas_company_agreed_price'];

    combineLatest([
      capacityControl.valueChanges.pipe(startWith(capacityControl.value)),
      percentageControl.valueChanges.pipe(startWith(percentageControl.value))
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([capacity, percentage]) => {
        const hasPercentage = percentage !== null && percentage !== undefined && `${percentage}`.trim() !== '';
        this.initialInventoryLiters.set(calculateInitialInventoryLiters(capacity, percentage));
        this.isZeroInitialInventory.set(hasPercentage && Number(percentage) === 0);
        this.selectLeaveInventoryAgreementWhenRequired();
      });

    percentageControl.valueChanges
      .pipe(
        startWith(percentageControl.value),
        map(value => value !== null && value !== undefined && `${value}`.trim() !== '' && Number(value) === 0
          ? 0
          : undefined),
        distinctUntilChanged(),
        switchMap(initialPercentage => this.store.getAgreements(initialPercentage).pipe(
          catchError(() => of([] as InventoryAgreement[]))
        )),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(agreements => {
        this.agreements.set(agreements);
        this.selectLeaveInventoryAgreementWhenRequired();
      });

    agreementControl.valueChanges
      .pipe(startWith(agreementControl.value), takeUntilDestroyed(this.destroyRef))
      .subscribe(value => this.selectedAgreementId.set(value === '' || value === null ? null : Number(value)));

    buildingControl.valueChanges
      .pipe(
        startWith(buildingControl.value),
        distinctUntilChanged(),
        switchMap(buildingId => {
          if (!buildingId || this.idTank()) {
            return of(null);
          }
          this.pricePreviewLoading.set(true);
          return this.store.getTankPricePreview(buildingId).pipe(
            catchError(() => {
              this.toastr.error('No fue posible obtener el precio y costo del edificio.');
              return of({ region_price: null, sale_price: null, cost: null } as TankPricePreview);
            }),
            finalize(() => this.pricePreviewLoading.set(false))
          );
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(preview => {
        if (preview) {
          this.pricePreview.set(preview);
        } else if (!this.idTank()) {
          this.pricePreview.set({ region_price: null, sale_price: null, cost: null });
        }
      });

    gasCompanyPriceControl.valueChanges
      .pipe(startWith(gasCompanyPriceControl.value), takeUntilDestroyed(this.destroyRef))
      .subscribe(value => this.externalGasCompanyPrice.set(this.toNullableNumber(value)));
  }

  private selectLeaveInventoryAgreementWhenRequired() {
    if (!this.isZeroInitialInventory()) {
      return;
    }

    const leaveAgreement = findLeaveInventoryAgreement(this.agreements());
    if (leaveAgreement && this.ufc['inventory_agreement_id'].value !== leaveAgreement.id) {
      this.ufc['inventory_agreement_id'].setValue(leaveAgreement.id);
    }
  }

  private hydrateEconomicData(tank: Tanque) {
    this.pricePreview.set({
      region_price: this.toNullableNumber(tank.region_price),
      sale_price: this.toNullableNumber(tank.sale_price),
      cost: this.toNullableNumber(tank.cost)
    });
    this.debitedAmount.set(this.toNullableNumber(tank.debited_amount));
    this.inventoryReplacementCost.set(this.toNullableNumber(tank.inventory_replacement_cost));
    this.inventoryPaymentTotal.set(this.toNullableNumber(tank.inventory_payment_total));
    this.externalGasCompanyPrice.set(this.toNullableNumber(tank.external_gas_company_agreed_price));
    this.hasInventoryPaymentPdf.set(Boolean(tank.inventory_payment_pdf_url));
    this.hasInventoryPaymentXml.set(Boolean(tank.inventory_payment_xml_url));
    this.inventoryPaymentPdfUrl.set(this.resolveInventoryDocumentUrl(tank.inventory_payment_pdf_url));
    this.inventoryPaymentXmlUrl.set(this.resolveInventoryDocumentUrl(tank.inventory_payment_xml_url));
  }

  private resolveInventoryDocumentUrl(value: string | null | undefined): string | null {
    if (!value?.trim()) return null;
    try {
      const url = new URL(value.trim(), `${environment.AWS_REST_WSPREFIX.replace(/\/$/, '')}/`);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
    } catch {
      return null;
    }
  }

  private updateAgreementValidators(kind: InventoryAgreementKind) {
    const control = this.tanqueForm.controls['external_gas_company_agreed_price'];
    if (!control) {
      return;
    }
    if (kind === 'gas-company') {
      control.setValidators([Validators.required, Validators.min(0.01)]);
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity({ emitEvent: false });
  }

  openCreditNoteModal(template: TemplateRef<any>) {
    const settlementId = this.selectedSettlement()?.id ?? this.ufc['settlement_id'].value;
    if (!settlementId) {
      this.toastr.info('Selecciona primero el condominio o comercio.');
      return;
    }

    this.creditNoteForm.reset({
      unit_id: this.configuredCreditUnit()?.id ?? '',
      stamp_inventory_credit_note: this.configuredCreditUnit()?.stamp_inventory_credit_note ?? false
    });
    if (!this.isResidentialSettlement()) {
      this.creditNoteForm.controls['stamp_inventory_credit_note'].setValue(false);
    }
    this.loadSettlementUnits(settlementId);
    this.activeModalRef = this.modalService.open(template, { centered: true, size: 'lg' });
  }

  private loadSettlementUnits(settlementId: number | string) {
    this.unitsLoading.set(true);
    this.store.getUnitsBySettlement(settlementId)
      .pipe(finalize(() => this.unitsLoading.set(false)))
      .subscribe({
        next: (response: any) => {
          const resources = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
          const units: Unit[] = resources.map((resource: any) => ({
            ...(resource?.attributes ?? resource),
            id: Number(resource?.id ?? resource?.attributes?.id),
            receives_inventory_credit_note_discount: normalizeOptionalBoolean((resource?.attributes ?? resource).receives_inventory_credit_note_discount),
            stamp_inventory_credit_note: normalizeOptionalBoolean((resource?.attributes ?? resource).stamp_inventory_credit_note)
          }));
          this.units.set(units);
          const configuredUnits = units.filter(unit =>
            unit.receives_inventory_credit_note_discount === true
          );
          // Multiple recipients cannot be represented as a single selected unit.
          const configuredUnit = configuredUnits.length === 1 ? configuredUnits[0] : null;
          this.configuredCreditUnit.set(configuredUnit);
          if (this.creditNoteForm.pristine) {
            this.creditNoteForm.patchValue({
              unit_id: configuredUnit?.id ?? '',
              stamp_inventory_credit_note: this.isResidentialSettlement()
                && configuredUnit?.stamp_inventory_credit_note === true
            });
          }
        },
        error: () => {
          this.units.set([]);
          this.toastr.error('No fue posible obtener las unidades disponibles.');
        }
      });
  }

  unitDisplayName(unit: Unit): string {
    return unit.name || unit.number || `Unidad ${unit.id}`;
  }

  saveCreditNoteConfiguration() {
    if (this.creditConfigurationSaving() || this.unitsLoading() || this.approvalComplete()) return;
    if (this.creditNoteForm.invalid) {
      this.creditNoteForm.markAllAsTouched();
      return;
    }

    const unitId = this.creditNoteForm.controls['unit_id'].value;
    if (!this.units().some(unit => Number(unit.id) === Number(unitId))) {
      this.toastr.error('Selecciona una unidad de este cliente.');
      return;
    }
    const configuration = {
      receives_inventory_credit_note_discount: true,
      stamp_inventory_credit_note: this.isResidentialSettlement()
        ? Boolean(this.creditNoteForm.controls['stamp_inventory_credit_note'].value)
        : false
    };
    const previousRecipients = this.units().filter(unit =>
      Number(unit.id) !== Number(unitId) && unit.receives_inventory_credit_note_discount === true
    );
    this.creditConfigurationSaving.set(true);
    from(previousRecipients).pipe(
      concatMap(unit => this.store.updateUnitInventoryCreditConfiguration(unit.id!, {
        receives_inventory_credit_note_discount: false,
        stamp_inventory_credit_note: false
      })),
      toArray(),
      switchMap(() => this.store.updateUnitInventoryCreditConfiguration(unitId, configuration)),
      finalize(() => this.creditConfigurationSaving.set(false))
    )
      .subscribe({
        next: () => {
          this.units.update(units => units.map(unit => ({
            ...unit,
            receives_inventory_credit_note_discount: Number(unit.id) === Number(unitId),
            stamp_inventory_credit_note: Number(unit.id) === Number(unitId)
              && configuration.stamp_inventory_credit_note
          })));
          const unit = this.units().find(item => Number(item.id) === Number(unitId)) ?? null;
          this.configuredCreditUnit.set(unit);
          this.toastr.success('La unidad quedó configurada para recibir la nota de crédito.');
          this.dismissActiveModal();
        },
        error: () => {
          const settlementId = this.selectedSettlement()?.id ?? this.tanqueForm.controls['settlement_id'].value;
          if (settlementId) this.loadSettlementUnits(settlementId);
          this.toastr.error('No fue posible completar la configuración. Revisa la unidad y vuelve a guardar.');
        }
      });
  }

  openInventoryPaymentModal(template: TemplateRef<any>) {
    if (!this.idTank()) {
      this.toastr.info('Guarda primero el tanque para adjuntar la factura.');
      return;
    }
    if (this.inventoryAgreementRequiresSave()) {
      this.toastr.info('Guarda el cambio de acuerdo antes de cargar la factura.');
      return;
    }
    this.invoicePdfFile.set(null);
    this.invoiceXmlFile.set(null);
    this.activeModalRef = this.modalService.open(template, { centered: true, size: 'lg' });
  }

  selectInventoryPaymentFile(event: Event, type: 'pdf' | 'xml') {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] ?? null;
    if (!file) {
      return;
    }
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (extension !== type) {
      this.toastr.error(`Selecciona un archivo ${type.toUpperCase()}.`);
      input.value = '';
      return;
    }
    if (type === 'pdf') {
      this.invoicePdfFile.set(file);
    } else {
      this.invoiceXmlFile.set(file);
    }
  }

  uploadInventoryPaymentFiles() {
    if (this.invoiceUploading() || this.approvalComplete() || this.inventoryAgreementRequiresSave()) return;
    const tankId = this.idTank();
    if (!tankId) {
      return;
    }
    const uploads: Observable<InventoryPaymentUploadResult>[] = [];
    const pdfFile = this.invoicePdfFile();
    const xmlFile = this.invoiceXmlFile();
    if (pdfFile) {
      uploads.push(this.createInventoryPaymentUpload(tankId, 'pdf', pdfFile));
    }
    if (xmlFile) {
      uploads.push(this.createInventoryPaymentUpload(tankId, 'xml', xmlFile));
    }
    if (uploads.length === 0) {
      this.toastr.info('Selecciona al menos un archivo.');
      return;
    }

    this.invoiceUploading.set(true);
    forkJoin(uploads).pipe(finalize(() => this.invoiceUploading.set(false)))
      .subscribe({
        next: results => {
          const failedUploads = results.filter(result => !result.success);
          if (failedUploads.length === results.length) {
            this.toastr.error('No fue posible guardar los archivos seleccionados.');
            return;
          }
          if (failedUploads.length > 0) {
            const failedTypes = failedUploads.map(result => result.type.toUpperCase()).join(' y ');
            this.toastr.warning(`Se guardó parte de la factura. Vuelve a intentar el archivo ${failedTypes}.`);
            return;
          }
          if (this.hasInventoryPaymentPdf() && this.hasInventoryPaymentXml()) {
            this.toastr.success('La factura quedó completa y el inventario se marcó como pagado.');
            this.dismissActiveModal();
            return;
          }
          this.toastr.success('El archivo quedó guardado. Falta completar la documentación de la factura.');
        }
      });
  }

  private createInventoryPaymentUpload(
    tankId: number,
    type: 'pdf' | 'xml',
    file: File
  ): Observable<InventoryPaymentUploadResult> {
    return this.store.uploadTankInventoryPaymentFile(tankId, type, file).pipe(
      tap(response => {
        this.applyInventoryPaymentResponse(response);
        if (type === 'pdf') {
          this.hasInventoryPaymentPdf.set(true);
          this.invoicePdfFile.set(null);
        } else {
          this.hasInventoryPaymentXml.set(true);
          this.invoiceXmlFile.set(null);
        }
      }),
      map((): InventoryPaymentUploadResult => ({ type, success: true })),
      catchError(() => of({ type, success: false } as InventoryPaymentUploadResult))
    );
  }

  private applyInventoryPaymentResponse(response: any) {
    const attributes = response?.data?.attributes ?? response?.data ?? response;
    const total = this.toNullableNumber(attributes?.inventory_payment_total);
    if (total !== null) {
      this.inventoryPaymentTotal.set(total);
    }
    if (attributes?.inventory_payment_pdf_url) {
      this.hasInventoryPaymentPdf.set(true);
      this.inventoryPaymentPdfUrl.set(this.resolveInventoryDocumentUrl(attributes.inventory_payment_pdf_url));
    }
    if (attributes?.inventory_payment_xml_url) {
      this.hasInventoryPaymentXml.set(true);
      this.inventoryPaymentXmlUrl.set(this.resolveInventoryDocumentUrl(attributes.inventory_payment_xml_url));
    }
  }

  dismissActiveModal() {
    this.activeModalRef?.dismiss();
    this.activeModalRef = undefined;
  }

  private toNullableNumber(value: unknown): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  selectSettlement(eventOrValue: any) {
    const value = eventOrValue?.target ? eventOrValue.target.value : eventOrValue;
    if (!value) {
      this.buildings = [];
      return;
    }
    this.getBuildings(value);
  }

  getBuildings(settlementId: any) {
    this.onLoading.emit(true);
    this.store.getBuildingsBySettlement(settlementId).subscribe({
      next: (buildings: any) => {
      this.buildings = buildings;
      this.onLoading.emit(false);
    }
    });
  }

  // loadBuildings() {};

  parentTanque(event: any) {
    this.hasParent = event.target.checked;
    this.updateParentValidator();
  }

  private updateParentValidator() {
    const parentControl = this.tanqueForm.controls['parent_tanque_id'];
    if (this.hasParent) {
      parentControl.setValidators([Validators.required]);
    } else {
      parentControl.clearValidators();
      parentControl.setValue(null);
    }
    parentControl.updateValueAndValidity();
  }

  saveForm() {
    this.loading = false;
    if (this.tanqueForm.invalid) {
      const controls = Object.keys(this.tanqueForm.controls).filter(k => this.tanqueForm.controls[k].invalid);
      console.info(`Invalid form in controls: ${controls}`);
      this.toastr.error('Formulario invalido');
      this.tanqueForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    const payload = { ...this.tanqueForm.value };
    if (this.selectedAgreementKind() !== 'gas-company') {
      delete payload.external_gas_company_agreed_price;
    }
    this.updateForm.emit(payload);
    this.loading = false;
  }  

  cancel() {
    console.log('cancel');
    this.cancelForm.emit();
  }
}
